import { Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { REVIEWS } from "@/data/projects";

const Stars = ({ n }) => (
  <div className="flex gap-1" aria-label={`${n} van 5 sterren`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-4 w-4 ${i <= n ? "fill-[#2F3438] text-[#2F3438]" : "text-[#2F3438]/20"}`} />
    ))}
  </div>
);

export const Reviews = () => (
  <section className="bg-[#F7F7F5] py-24 md:py-32" data-testid="reviews-section">
    <div className="mx-auto max-w-[1440px] px-6 md:px-10">
      <div className="flex items-end justify-between gap-6 flex-wrap">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-[#222]/40">Klantbeoordelingen</span>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#2F3438] mt-6">Wat klanten zeggen.</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex items-center gap-3" data-testid="reviews-average">
            <span className="font-display font-extrabold text-4xl text-[#2F3438]">4,9</span>
            <div>
              <Stars n={5} />
              <span className="text-xs text-[#222]/50 mt-1 block">gemiddelde beoordeling</span>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#ECECEA] border border-[#ECECEA]">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={i * 0.08} className="bg-white p-10 flex flex-col">
            <Stars n={r.stars} />
            <p className="font-display text-lg text-[#2F3438] leading-relaxed mt-6 flex-1">“{r.quote}”</p>
            <div className="mt-8">
              <div className="font-medium text-[#2F3438]">{r.name}</div>
              <div className="text-sm text-[#222]/50">{r.place}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
